import * as _ from 'lodash'
import React from 'react';
import util from '../util';
import globalRelay from '../globalRelay';
import * as jobActions from '../jobActions';import * as statsActions from '../statsActions';import enums from '../enum';
import componentServices from '../componentServices';

import { SalesPerformanceChart, sortableComponent, Spinner } from './sharedComponents';
import store, { getCollection, ModelCollection } from '../store';

const Table = sortableComponent(({ updateSort, sortKey, list, totals, ...childProps }) => {
	const { countLeads, countProspects, countCustomers, sumProjected, sumContracted, sumTotal } = totals;
	const rows:JSX.Element[] = [];

	list.forEach((item) => {
		rows.push(<TableRow item={item} key={item.employeeKey} {...childProps} />);
	});

	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<TableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<tbody>
				{rows}
			</tbody>
			<tfoot className="total">
				<tr>
					<td />
					<td>Total</td>
					<td className="quantity">{ countLeads }</td>
					<td className="quantity">{ countProspects }</td>
					<td className="quantity">{ countCustomers }</td>
					<td className="cost">$ {util.formatScaled(sumProjected)}</td>
					<td className="cost green">$ {util.formatScaled(sumContracted)}</td>
					<td className="cost">$ {util.formatScaled(sumTotal)}</td>
					<td />
					<td />
				</tr>
			</tfoot>
		</table>
	);
});

class TableHeader extends React.Component<any,any> {
	handleClick (path, e) {
		e.preventDefault();
		this.props.updateSort(path);
	}
	getClassName (key, classes = [] as any[]) {
		if (key === this.props.sortKey) {
			classes.push('sorted');
		}
		return classes.join(' ');
	}
	render () {
		return (<thead>
			<tr>
				<td></td>
				<td className={ this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Salesperson</td>
				<td className={ this.getClassName('countLeads', ['quantity'])} onClick={this.handleClick.bind(this, 'countLeads')}>Leads</td>
				<td className={ this.getClassName('countProspects', ['quantity'])} onClick={this.handleClick.bind(this, 'countProspects')}>Prospects</td>
				<td className={ this.getClassName('countCustomers', ['quantity'])} onClick={this.handleClick.bind(this, 'countCustomers')}>Clients</td>
				<td className={ this.getClassName('sumProjected', ['cost'])} onClick={this.handleClick.bind(this, 'sumProjected')}>Projected</td>
				<td className={ this.getClassName('sumContracted', ['green cost'])} onClick={this.handleClick.bind(this, 'sumContracted')}>Contracted</td>
				<td className={ this.getClassName('sumTotal', ['cost'])} onClick={this.handleClick.bind(this, 'sumTotal')}>Total Fiscal Year</td>
				<td />
				<td />
			</tr>
		</thead>);
	}
}

class TableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}
	handleClick (e) {
		const { item } = this.props;

		e.preventDefault();

		componentServices.router.pushHistory(componentServices.router.splicePathSegments(1, 1, 'jobs'), { employeeKey: item.employeeKey });
	}
	render () {
		const { item } = this.props;

		return (
			<tr onClick={ this.handleClick }>
				<td />
				<td>{ item.name }</td>
				<td className="quantity">{ item.countLeads }</td>
				<td className="quantity">{ item.countProspects }</td>
				<td className="quantity">{ item.countCustomers }</td>
				<td className="cost">$ {util.formatScaled(item.sumProjected)}</td>
				<td className="cost green">$ {util.formatScaled(item.sumContracted)}</td>
				<td className="cost">$ {util.formatScaled(item.sumTotal) }</td>
				<td />
				<td />
			</tr>
		);
	}
}

export default class SalesPerformance extends React.Component<any,any> {
	constructor (props) {
		super(props);
	}

	componentDidMount () {
		statsActions.fetchFiscalYears()
			.then(() => {
				const currentModule = componentServices.store.getIn(['viewState', 'currentModule']);
				const businessSegment = (currentModule === 'retail-sales' ? enums.businessSegments.Retail : currentModule === 'builder-sales' ? enums.businessSegments.Builder : enums.businessSegments.Unknown);
				const now = new Date();
				const fiscalYear = getCollection({ collection: ModelCollection.fiscalYears}).find(fy => fy.startDate <= now && fy.endDate > now);
				jobActions.fetchJobsForFYSalesStats({ businessSegment, fiscalYear });
			});
	}

	getSumGoal() {
		const jobStats = componentServices.store.getIn(['viewState', 'searchResults', 'jobStats']);
		let sumGoal = 0;
		
		if(jobStats) {
			const { store } = componentServices;
			const employees = getCollection({ store, collection: ModelCollection.employees });
			const fiscalYear = jobStats.fiscalYear.year;
			employees.forEach(e => {
				sumGoal += Number((e && e.getProfileValue(`salesGoalFY${fiscalYear}`, '0')) || '0');
			});
		}
		
		return sumGoal;
	}

	render () {
		const { store } = componentServices;
		const { businessSegment } = this.props;
		const jobStats = store.getIn(['viewState', 'searchResults', 'jobStats']);
		const employees = getCollection({ store, collection: ModelCollection.employees });
		const globalConfig = globalRelay.config!;
		const roleTitleTests = globalConfig.systemRoleEmployeeTitleTests;
		const roleTests = businessSegment === enums.businessSegments.Retail ? roleTitleTests.designer : roleTitleTests.accountManager;
		// this creates an array out of the object
		const list = jobStats && _.filter(jobStats.aggregates.accountManager, () => true);
		const sumGoal = this.getSumGoal();
		

		// be sure that all salespeople are listed even if they have no stats
		employees.forEach(e => {
			if (!jobStats || jobStats.aggregates.accountManager[e.key]) {
				return;
			}
			const isSalesperson = _.reduce(roleTests, (r, v) => {
				if (!r) {
					const test = new RegExp(v, 'i');
					r = test.test(e.orgTitleKey);
				}
				return r;
			}, false);

			if (isSalesperson) {
				list.push({
					employeeKey: e.key,
					name: e.fullName,
					countLeads: 0,
					countProspects: 0,
					countCustomers: 0,
					sumProjected: 0,
					sumContracted: 0,
					sumTotal: 0
				});
			}
		});

		return (
			<section>
				{ !jobStats ? <div className="chart performanceChart"><Spinner classNames={ ['dark'] } /></div>
					: <SalesPerformanceChart sumGoal = {sumGoal} fiscalYear={ jobStats.fiscalYear } startDate={ jobStats.startDate } aggregates={ jobStats.aggregates } />
				}
				{ !jobStats ? null : <div className="inner">
					<Table list={ list } initialSortKey="name" sortDateLabel="Added On" totals={ jobStats.aggregates } />
				</div>
				}
			</section>
		);
	}
}